module.exports = __webpack_public_path__ + "img/icon-stairs.1969acc0.svg";